interface IpInfo {
  ipAddress: string
  continentCode: string
  continentName: string
  countryCode: string
  countryName: string
  city: string
}

export async function getIpFingerprint(): Promise<IpInfo | null> {
  // 请求ip地址，将数据存在cookie中，下次请求，如果cookie中存在，则不请求
  const cookie = document.cookie.split('; ').find(row => row.startsWith('ipInfo='))
  if (cookie) {
    const ipCookie = cookie.split('=')[1]
    if (ipCookie) {
      const ipInfo = JSON.parse(ipCookie)
      return ipInfo
    }
  }

  try {
    const response = await fetch('https://api.db-ip.com/v2/free/self')
    if (response.ok) {
      const data = await response.json()
      // 将数据存入cookie中，域名 import.meta.env.VITE_COOKIE_DOMAIN，10天后过期
      document.cookie = `ipInfo=${JSON.stringify(data)}; domain=${import.meta.env.VITE_COOKIE_DOMAIN}; path=/; expires=${new Date(Date.now() + 10 * 24 * 60 * 60 * 1000).toUTCString()}`
      return {
        ipAddress: data.ipAddress,
        continentCode: data.continentCode,
        continentName: data.continentName,
        countryCode: data.countryCode,
        countryName: data.countryName,
        city: data.city
      }
    }
  } catch (error) {
    console.error(`Error fetching IP from https://api.db-ip.com/v2/free/self:`, error)
  }

  return null
}
